module.exports = __webpack_public_path__ + "static/media/velour10A.42328ef7.jpg";